module.exports = __webpack_public_path__ + "img/xNew1.73912304.jpg";